import { render, staticRenderFns } from "./ExpandedReports.vue?vue&type=template&id=748d19c5&scoped=true&"
import script from "./ExpandedReports.vue?vue&type=script&lang=js&"
export * from "./ExpandedReports.vue?vue&type=script&lang=js&"
import style0 from "./ExpandedReports.vue?vue&type=style&index=0&id=748d19c5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748d19c5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VChip,VCol,VDataTable,VIcon,VRow})
